module.exports = __webpack_public_path__ + "static/media/minus.25d990f0.svg";